(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AgentsVideo',
	};

	const video  = document.getElementById('video_box');
	let recorder = null;
	var blobUrl,
		blobber,
		scroll_interval,
		current_position = 0,
		scroll_speed     = 10, // defaults to slow
		camera_on        = false,
		recording        = false,
		scrolling        = false;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('#camera_start').on('click', function _startStopCamera() {
			startStopCamera();
		});

		$('#video_start').on('click', function _startRecording() {
			recordStream();
		});

		$('#video_replay').on('click', function _replayVideo() {
			video.pause();
			video.currentTime = '0';
			video.play();
		});

		$('#btn-horizontal').on('click', function _setOrientation(e) {
			var location = 'below';

			if ($('#btn-above').hasClass('active')) {
				location = 'above';
			}

			e.preventDefault();

			window.location.href = Adzuki.base_uri + '/Videos/setOrientation/horizontal/' + location;
		});

		$('#btn-vertical').on('click', function _setOrientation(e) {
			var location = 'below';

			if ($('#btn-above').hasClass('active')) {
				location = 'above';
			}

			e.preventDefault();

			window.location.href = Adzuki.base_uri + '/Videos/setOrientation/vertical/' + location;
		});

		$('#btn-above').on('click', function _setLocation(e) {

			e.preventDefault();

			window.location.href = Adzuki.base_uri + '/Videos/setLocation/above';
		});

		$('#btn-below').on('click', function _setLocation(e) {

			e.preventDefault();

			window.location.href = Adzuki.base_uri + '/Videos/setLocation/below';
		});

		$('#video_send').on('click', function _sendVideo() {
			var fd                      = new FormData(),
				video_file              = new File([blobber], "video.webm", {type: 'video/webm'}),
				title                   = $('#agentsvideo-title').val(),
				thumbnail_image         = $('#agentsvideo-thumbnail_image')[0].files[0],
				agent_video_category_id = $('#agentsvideo-agent_video_category_id').val(),
				description             = $('#agentsvideo-description').val(),
				shared_video            = 0,
				client_id               = $('#agentsvideo-neworexistingclient-0-existingclient-existing_client_id').val(),
				dupe_title              = false;

			if (title === '') {
				Adzuki.StatusMessage('error', 'Title is required.');
			} else {
				Adzuki.Ajax.get('/Videos/checkTitle/' + title)
				.then(function _showBrowserInfo(response) {
					dupe_title = response.dupe;


					if (dupe_title === true) {
						Adzuki.StatusMessage('error', 'The title provided has already been used by another video you already have. Please adjust the title to something unique.');
					} else {
						$('.video-processing').css('visibility', 'visible');

						if ($('#agentsvideo-shared_video').is(':checked') === true) {
							shared_video = 1;
						}

						fd.append('video_file', video_file);
						fd.append('title', title);
						fd.append('thumbnail_image', thumbnail_image);
						fd.append('agent_video_category_id', agent_video_category_id);
						fd.append('description', description);
						fd.append('shared_video', shared_video);
						fd.append('client_id', client_id);

						$.ajax({
							type       : 'POST',
							url        : Adzuki.base_uri + '/Videos/processVideo/',
							data       : fd,
							processData: false,
							contentType: false
						}).done(function _doneSentIt(data) {
							if (data.status === false) {
								Adzuki.StatusMessage('error', data.message);
							} else {
								window.location.href = Adzuki.base_uri + '/Videos/index/';
							}
						});
					}
				});
			}
		});

		$('.video-types').on('click', function _videoTypePressed(e) {
			if ($(this).prop('innerText') === 'Record') {
				$('.video-record').removeClass('hidden');
				$('.video-upload').addClass('hidden');

				$('#agentsvideo-active_type').val('recorded');
			} else {
				$('.video-record').addClass('hidden');
				$('.video-upload').removeClass('hidden');

				$('#agentsvideo-active_type').val('uploaded');
			}
		});

		$(window).keypress( function _toggleScrolling (e) {
			if ( e.target.nodeName === "INPUT" || e.target.nodeName === "TEXTAREA" ) {
				return;
			}

			if (e.key === ' ' || e.key === 'Spacebar') {
			  // ' ' is standard, 'Spacebar' was used by IE9 and Firefox < 37
			  
			  e.preventDefault();

				if (scrolling === false) {
					$('#scroll_start').trigger('click');
				} else {
					$('#scroll_stop').trigger('click');
				}
			}
			return false;
		});

		$('#scroll_start').on('click', function _startScrolling() {
			var transcript_container = $('.transcript'),
				$self                = $(this),
				$scroll_stop         = $('#scroll_stop');

			if (transcript_container.val() === '') {
				Adzuki.StatusMessage('error', 'Please put some content in the transcript box.');
			} else {
				scroll_speed = parseInt($('.speed').val());

				if (scrolling === false) {
					scroll_interval = setInterval(
						function _callTimer() {
							transcript_container.animate({ scrollTop: current_position });
							current_position = current_position + scroll_speed;
						},
						500
					);

					$self.text('Scrolling...');
					$self.addClass('disabled');
					$self.prop('disabled', true);

					$scroll_stop.text('Stop Scrolling');
					$scroll_stop.removeClass('disabled');
					$scroll_stop.prop('disabled', false);

					scrolling = true;

				}
			}
		});

		$('#agentsvideo-agent_video_category_id').on('change', function getSubCats(e) {
			var catId       = $(this).val();
			var parentLabel = $(this.options[this.selectedIndex]).parent().attr('label');

			if (parentLabel === 'Global Categories') {
				$('#subcat-input').addClass('hidden');
			}

			if ((catId !== '' || catId !== null) && parentLabel !== 'Global Categories') {
				Adzuki.Ajax.get('/Videos/getSubCatList/' + catId)
					.then(function success(data) {
						if (data[0] === 0) {
							$('#subcat-input').addClass('hidden');
						} else {
							$('#subcat-input').removeClass('hidden');
							$("#agentsvideo-agent_video_subcategory_id").html(data);
						}
					});
			}
		});

		$('#scroll_stop').on('click', function stopScrolling() {
			var $scroll_start = $('#scroll_start');
			
			clearInterval(scroll_interval);
			scroll_speed = parseInt($('.speed').val());
			scrolling    = false;
			
			$scroll_start.text('Start Scrolling');
			$scroll_start.removeClass('disabled');
			$scroll_start.prop('disabled', false);

			$(this).text('Stopped');
			$(this).addClass('disabled');
			$(this).prop('disabled', true);
		});

		$('#scroll_top').on('click', function _scrollToTop() {
			if ($('#scroll_start').is(':disabled')) {
				$('#scroll_stop').focus();
			} else {
				$('#scroll_start').focus();
			}
			$('.transcript').scrollTop(0);
			current_position = 0;
		});

		$(".transcript").on('paste', function _triggerScrollTop(e) {
			setTimeout(
				function _scrollTopAgain() {
					$('.transcript').scrollTop(0);
					current_position = 0;
				},
				100
			);
		});

		$('.fontsize').on('change', function _changeFontSize() {
			var fontsize = parseInt($(this).val());

			$(".transcript").css('font-size', fontsize + 'pt');
		});

		$('.speed').on('change', function _changeSpeed() {
			scroll_speed = parseInt($('.speed').val());

			// $(".transcript").css('font-size', fontsize + 'pt');
		});

		$('.video-instructions').on('click', function _showVideoInstructions(e) {
			var $modal = $(".modal");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-title').text('Video Instructions');
				$modal.find('.modal-body').text('Loading...');

				Adzuki.Ajax.get('/Videos/getBrowserInfo/')
				.then(function _showBrowserInfo(html) {
				$modal.find('.modal-body').html(html);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		resizeScriptBox();
	};

	$(window).on('resize', function _windowResize() {
		resizeScriptBox();
	});

	form.success = function success(response)
	{
		if ($('#agentsvideo-active_type').val() === 'recorded') {
			return true;
		}

		if ($('#agentsvideo-active_type').val() === 'uploaded') {
			if (!Adzuki.Form.hasError(response)) {
				window.location.href = response['data'];
			}
		}
	};

	/** VIDEO FUNCTIONS */
	async function captureMediaDevices(
		mediaConstraints = {
			video: {
				width : 1280,
				height: 720,
			},
			audio: {
				echoCancellation: true,
				noiseSuppression: true,
				sampleRate      : 44100,
			},
		}
	) {
		const stream = await navigator.mediaDevices.getUserMedia(mediaConstraints);
		video.src       = null;
		video.srcObject = stream;
		video.muted     = true;

		return stream;
	}

	async function startStopCamera() {
		// $('#video_box').attr('src', $('#video_box').data('src'));

		$('#video_replay').addClass('disabled');
		$('#video_replay').prop('disabled', true);

		$('#video_send').addClass('disabled');
		$('#video_send').prop('disabled', true);

		if (camera_on === false) {
			// turns camera on
			const stream = await captureMediaDevices();
			video.src       = null;
			video.srcObject = stream;
			video.muted     = true;

			camera_on = true;

			$('#camera_start').html('<i class="fa fa-video-slash"></i> Turn Off Camera');

			$('#video_start').removeClass('disabled');
			$('#video_start').prop('disabled', false);
		} else {
			// turns camera off
			camera_on         = false;
			const mediaStream = video.srcObject;

			if (mediaStream !== null) {
				const tracks = mediaStream.getTracks();
				tracks.forEach(track => track.stop());
			}

			video.src = '';

			$('#camera_start').html('<i class="fa fa-video"></i> Turn On Camera');

			$('#video_start').addClass('disabled');
			$('#video_start').prop('disabled', true);
		}
	}

	function stopRecording() {
		recorder.stream.getTracks().forEach(track => track.stop());
		recorder.stop();

		$('#camera_start').html('<i class="fa fa-video"></i> Turn On Camera');

		$('#video_start').addClass('disabled');
		$('#video_start').prop('disabled', true);

		$('#video_send').removeClass('disabled');
		$('#video_send').prop('disabled', false);

		$('.recording-text').addClass('hidden');

		recording = false;
		camera_on = false;
	}

	async function recordStream() {
		var video_size, 
			mime;

		if (recording === false) {
			$('#video_box').attr('src', $('#video_box').data('src'));
			$('.size-text').html('');

			animateRecording();

			$('#camera_start').addClass('disabled');
			$('#camera_start').prop('disabled', true);

			recording = true;
			recording = true;
			mime = MediaRecorder.isTypeSupported("video/webm; codecs=vp9") ? "video/webm; codecs=vp9" : "video/webm";

			recorder = new MediaRecorder(video.srcObject, {
				mimeType: mime
			});

			let chunks = [];

			recorder.ondataavailable = event => {
				if (event.data.size > 0) {
					chunks.push(event.data);
				}
			};

			recorder.onstop = () => {
				blobber = new Blob(chunks, {
					type: 'video/mp4'
				});

				chunks = [];
				blobUrl = URL.createObjectURL(blobber);

				video.srcObject = null;
				video.src       = blobUrl;
				video.muted     = false;
				video_size      = parseFloat(blobber.size/(1024 ** 2)).toFixed(2);

				// file size to show
				$('.size-text').removeClass('hidden');

				// if more than 100 MBS - can be changed
				if (video_size > 100) {
					$('.size-text').html('<h5 class="text-danger"><i class="fas fa-fw fa-exclamation-triangle"></i> Your Video Size (' + (video_size) + 'mb) is too large and cannot be uploaded.</h5>');
					$('#video_send').prop('disabled', true);
					$('#video_send').addClass('disabled');
				} else {
					$('.size-text').html('<h5>Video Size ' + (video_size) + 'mb</h5>');
				}
			};

			recorder.start(500);
			recording = true;
			$('#video_start').html('<i class="fa fa-stop"></i> Stop Recording');
		} else {
			stopRecording();

			$('#video_start').html('<i class="fa fa-record-vinyl"></i> Start Recording');
			$('#camera_start').removeClass('disabled');
			$('#camera_start').prop('disabled', false);
			$('#video_replay').removeClass('disabled');
			$('#video_replay').prop('disabled', false);
		}
	}

	function resizeScriptBox() {
		$('.transcript').css('height', $('#video_box').css('height'));
	}

	function animateRecording() {
		$('.recording-text').removeClass('hidden');
		blink($('.recording-text'));
	}

	function blink(selector) {
		$(selector).fadeOut('slow', function _fadeIt() {
			$(this).fadeIn('slow', function _fadeUp() {
				blink(this);
			});
		});
	}
}(jQuery, window.Adzuki || {}));
